/** Application-wide color constants extracted from the Python BushingApp class. */

export const ACCENT_COLOR = '#5e503f';
export const SURFACE_BG = 'rgba(255,255,255,0.9)';

/** Plot trace colors */
export const TRAINING_DATA_COLOR = '#1f77b4'; // training data (bright blue)
export const GENERATED_SAMPLE_COLOR = '#ff7f0e'; // new samples (vivid orange)
export const SELECT_COLOR = '#2ca02c'; // selected sample (green)
export const UNSELECTED_OPACITY = 0.12; // faint non-selected points

/** Target point styling */
export const TARGET_COLOR = '#9467bd'; // purple
export const TARGET_SYMBOL = 'x'; // cross marker

/** Font sizes (px) for plot axes / legends / hover */
export const AXIS_TITLE_SIZE = 15;
export const TICK_FONT_SIZE = 13;
export const LEGEND_FONT_SIZE = 13;
export const HOVER_FONT_SIZE = 12;
